module.exports = __webpack_public_path__ + "img/punga-main.7d508fe4.webp";